import { Inject, Injectable, InjectionToken } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { SecurityService, type StateDeclaration } from '@tdwb/core';
import type { Transition, TransitionService, TargetState } from '@uirouter/angular';

export const ROUTER_UNAUTHORIZED_URL_CONFIGURATION = new InjectionToken<string>('unauthorizedUrl');

/**
 * This Router service is responsible for authorizing  the state
 */
@Injectable({
  providedIn: 'root'
})
export class RouterSecurityService {
  constructor(@Inject(SecurityService) private securityService: SecurityService,
              @Inject(ROUTER_UNAUTHORIZED_URL_CONFIGURATION) private unauthorizedUrl: string,
              @Inject(StateService) private stateService: StateService) {
  }

  static initHooks(transitionService: TransitionService): void {
    transitionService.onStart(
      { to: '**' }, (transition: Transition): TargetState | void => {
        const routerSecurityService: RouterSecurityService = transition.injector().get(RouterSecurityService);
        return routerSecurityService.handlePageTransition(transition);
      });
  }

  private handlePageTransition(transition: Transition): TargetState | void {
    const toState = transition.to();
    if (!this.securityService.isAuthorizedState(toState as StateDeclaration)) {
      return this.stateService.target(this.unauthorizedUrl);
    }
  }
}
